<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card class="pt-1">
        <v-container fluid class="pa-0">

            <!-- INSUFFICIENT PERMISSIONS -->
            <v-row v-if="!hasPermission('view panelists')">
                <v-col cols="12">
                    <v-card>
                        <v-card-text>
                            <v-alert icon="mdi-alert" v-if="!hasPermission('view pi')" type="error" class="body-2">
                                Insufficient permissions
                            </v-alert>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- AT LEAST MINIMUM PERMISSIONS -->
            <v-row v-else>

                <v-col cols="12" class="pt-0">
                    <v-card class="pa-0" flat>
                        <v-card-text class="pa-0">
                            <v-container fluid class="pb-0">
                                <v-row no-gutters>
                                    <v-col cols="12">

                                        <div class="d-flex flex-wrap">

                                            <!-- HELP -->
                                            <div class="align-self-center pr-10">
                                                <help-icon help="edit-panelist-variables"></help-icon>
                                            </div>

                                            <!-- SHOW EDITABLE SWITCH -->
                                            <div class="align-self-center flex-grow-1">
                                                <v-switch
                                                    color="primary"
                                                    v-model="editableOnly"
                                                    label="Show editable only"
                                                ></v-switch>
                                            </div>

                                            <!-- FILTER BY GROUP -->
                                            <div class="align-self-center pb-5">
                                                <v-autocomplete
                                                    hide-details
                                                    prepend-icon="mdi-filter"
                                                    :items="availableGroups"
                                                    v-model="filterModel"
                                                    clearable
                                                    label="Filter by group"
                                                ></v-autocomplete>
                                            </div>

                                            <!-- SEARCH FIELD -->
                                            <div class="align-self-center pb-5">
                                                <v-text-field
                                                    hide-details
                                                    :height="32"
                                                    prepend-icon="mdi-magnify" q
                                                    label="Search"
                                                    v-model="searchTerm"
                                                    clearable
                                                ></v-text-field>
                                            </div>

                                        </div>

                                    </v-col>

                                    <v-col cols="12" class="mb-2" v-if="hasPermission('view panelists')">

                                        <title-card :loading="loading"
                                                    :title="'Data Variables ('+variableCount+')'"
                                                    no-padding>
                                            <template v-slot:buttons>

                                                <v-btn v-show="modified"
                                                       small
                                                       color="primary"
                                                       class="mr-2"
                                                       @click="saveClicked">Save changes
                                                </v-btn>

                                                <v-btn color="primary" small @click="addVariablesClicked">
                                                    Add variables
                                                </v-btn>
                                            </template>

                                            <div :key="formKey" class="pb-2 pt-1">
                                                <div v-for="item in filteredData" :key="item.dataVariable.uuid">

                                                    <v-scale-transition>
                                                        <data-variable-text
                                                            v-if="item.dataVariable.type === 'text'"
                                                            v-show="!(!item.dataVariable.panelist_writable && editableOnly)"
                                                            :variable="item.dataVariable"
                                                            :value="item.recorded_value"
                                                            :error-messages="errorBag"
                                                            @input="inputChanged"
                                                            @delete="deleteVariable"
                                                        ></data-variable-text>
                                                    </v-scale-transition>

                                                    <v-scale-transition>
                                                        <data-variable-phone
                                                            v-if="item.dataVariable.type === 'phone'"
                                                            v-show="!(!item.dataVariable.panelist_writable && editableOnly)"
                                                            :variable="item.dataVariable"
                                                            :value="item.recorded_value"
                                                            :error-messages="errorBag"
                                                            @input="inputChanged"
                                                            @invalid="invalid = true"
                                                            @delete="deleteVariable"
                                                        ></data-variable-phone>
                                                    </v-scale-transition>

                                                    <v-scale-transition>
                                                        <data-variable-keyword
                                                            v-if="item.dataVariable.type === 'keyword'"
                                                            v-show="!(!item.dataVariable.panelist_writable && editableOnly)"
                                                            :variable="item.dataVariable"
                                                            :value="item.recorded_value"
                                                            :error-messages="errorBag"
                                                            @input="inputChanged"
                                                            @delete="deleteVariable"
                                                        ></data-variable-keyword>
                                                    </v-scale-transition>

                                                    <v-scale-transition>
                                                        <data-variable-number
                                                            v-if="item.dataVariable.type === 'number'"
                                                            v-show="!(!item.dataVariable.panelist_writable && editableOnly)"
                                                            :variable="item.dataVariable"
                                                            :value="item.recorded_value"
                                                            :error-messages="errorBag"
                                                            @input="inputChanged"
                                                            @delete="deleteVariable"
                                                        ></data-variable-number>
                                                    </v-scale-transition>

                                                    <v-scale-transition>
                                                        <data-variable-locale
                                                            v-if="item.dataVariable.type === 'locale'"
                                                            v-show="!(!item.dataVariable.panelist_writable && editableOnly)"
                                                            :variable="item.dataVariable"
                                                            :value="item.recorded_value"
                                                            :locales="availableLocales"
                                                            :error-messages="errorBag"
                                                            @input="inputChanged"
                                                            @delete="deleteVariable"
                                                        ></data-variable-locale>
                                                    </v-scale-transition>

                                                    <v-scale-transition>
                                                        <data-variable-date
                                                            v-if="item.dataVariable.type === 'date'"
                                                            v-show="!(!item.dataVariable.panelist_writable && editableOnly)"
                                                            :variable="item.dataVariable"
                                                            :value="item.recorded_value"
                                                            @input="inputChanged"
                                                            @delete="deleteVariable"
                                                        ></data-variable-date>
                                                    </v-scale-transition>

                                                    <v-scale-transition>
                                                        <data-variable-radio
                                                            v-if="item.dataVariable.type === 'radio'"
                                                            v-show="!(!item.dataVariable.panelist_writable && editableOnly)"
                                                            :variable="item.dataVariable"
                                                            :value="item.recorded_value"
                                                            :error-messages="errorBag"
                                                            @input="inputChanged"
                                                            @delete="deleteVariable"
                                                        ></data-variable-radio>
                                                    </v-scale-transition>

                                                    <v-scale-transition>
                                                        <data-variable-checkbox
                                                            v-if="item.dataVariable.type === 'checkbox'"
                                                            v-show="!(!item.dataVariable.panelist_writable && editableOnly)"
                                                            :variable="item.dataVariable"
                                                            :value="item.recorded_value"
                                                            :error-messages="errorBag"
                                                            @input="inputChanged"
                                                            @delete="deleteVariable"
                                                        ></data-variable-checkbox>
                                                    </v-scale-transition>

                                                    <v-scale-transition>
                                                        <data-variable-email
                                                            v-if="item.dataVariable.type === 'email'"
                                                            v-show="!(!item.dataVariable.panelist_writable && editableOnly)"
                                                            :variable="item.dataVariable"
                                                            :value="item.recorded_value"
                                                            :error-messages="errorBag"
                                                            @input="inputChanged"
                                                            @delete="deleteVariable"
                                                        ></data-variable-email>
                                                    </v-scale-transition>
                                                </div>
                                            </div>

                                        </title-card>
                                    </v-col>

                                    <v-col sm12 md="12" v-show="modified">

                                        <v-btn color="primary"
                                               class="mb-4"
                                               @click="saveClicked">Save changes
                                        </v-btn>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

        </v-container>

        <data-variable-picker
            v-if="variablePickerModel"
            v-model="variablePickerModel"
            @close="variablePickerModel=false"
            multiple
            :data-variables="availableDataVariables"
            @change="dataVariablesChanged"
        ></data-variable-picker>

        <json v-if="debug" :data="variables"/>

    </v-card>
</template>

<script>

import Json from 'vue-json-pretty';
import StatBoxNumerical from "../../../../components/UI/StatBoxNumerical";
import DataVariableText from '../DataVariableFields/DataVariableText';
import DataVariableNumber from '../DataVariableFields/DataVariableNumber';
import DataVariableRadio from '../DataVariableFields/DataVariableRadio';
import DataVariableCheckbox from '../DataVariableFields/DataVariableCheckbox';
import DataVariableDate from '../DataVariableFields/DataVariableDate';
import DataVariableEmail from '../DataVariableFields/DataVariableEmail';
import DataVariableKeyword from '../DataVariableFields/DataVariableKeyword';
import DataVariableLocale from "../DataVariableFields/DataVariableLocale";
import DataVariablePhone from "../DataVariableFields/DataVariablePhone";
import DataVariablePicker from "../../../../components/UI/DataVariablePicker";

import {mapState, mapActions, mapMutations} from 'vuex';
import TitleCard from "../../../../components/UI/TitleCard";
import HelpIcon from "../../../../components/UI/HelpIcon";

export default {

    components: {
        HelpIcon,
        Json,
        TitleCard,
        StatBoxNumerical,
        DataVariableText,
        DataVariableNumber,
        DataVariableRadio,
        DataVariableCheckbox,
        DataVariableDate,
        DataVariableEmail,
        DataVariableKeyword,
        DataVariableLocale,
        DataVariablePhone,
        DataVariablePicker
    },

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    mounted() {

        this.getDataVariables()
            .catch(() => {
                Bus.$emit('flash-message', {type: 'error', message: 'OOPS We failed to load available data variables'})
            });

        if (this.data.data_variables.length > 0) {
            this.buildVariables();
        }
    },

    watch: {
        data(data) {
            if (data.data_variables.length > 0) {
                this.buildVariables();

                // Force re-render of all components
                this.formKey++;
            }
        }
    },

    data() {
        return {
            debug: false,
            variables: [],      // Original data
            dirtyVariables: [], // Answer data
            modified: false,
            speedDialModel: false,
            variablePickerModel: false,
            loading: false,
            formKey: 1,
            errorBag: {},
            invalid: false,
        }
    },

    computed: {

        // Root store
        ...mapState([
            'dataVariables'
        ]),

        ...mapState('SubPanels', [
            'subPanels'
        ]),

        ...mapState('PanelistManager', [
            'variablesEditableOnly',
            'variablesFilterModel',
            'variablesSearchTerm'
        ]),

        variableCount() {
            return this.data.data_variables.length;
        },

        availableLocales() {
            if (this.data && this.subPanels) {

                const subPanel = this.subPanels.find(subPanel => subPanel.uuid === this.data.sub_panels[0])

                if (subPanel) {
                    return subPanel.locales;
                }
            }
        },

        availableGroups() {

            const groupNames = this.variables.map(variable => {

                if (!variable.dataVariable.group) {
                    return 'NO GROUP';
                }

                return variable.dataVariable.group.name;
            });

            // Trick -> move NO GROUP first in the array of unique group names
            return [...['NO GROUP'], ...new Set(groupNames)];
        },

        editableOnly: {
            get() {
                return this.variablesEditableOnly;
            },
            set(toggle) {
                this.setVariablesEditableOnly(toggle);
            }
        },
        searchTerm: {
            get() {
                return this.variablesSearchTerm;
            },
            set(searchTerm) {
                this.setVariablesSearchTerm(searchTerm);
            }
        },
        filterModel: {
            get() {
                return this.variablesFilterModel;
            },
            set(model) {
                this.setVariablesFilterModel(model);
            }
        },
        filteredData: {
            get() {

                let filtered = JSON.parse(JSON.stringify(this.variables));

                // Group based filter
                if (this.variablesFilterModel) {
                    filtered = filtered.filter(item => {
                        if (this.variablesFilterModel === "NO GROUP") {
                            return !item.dataVariable.group;
                        }

                        if (!item.dataVariable.group) return false;

                        return item.dataVariable.group.name === this.variablesFilterModel;
                    });
                }

                // Search term filter
                if (this.variablesSearchTerm && this.variablesSearchTerm.length > 0) {

                    // $& means the whole matched string
                    const cleanSearchTerm = this.variablesSearchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

                    // Include partial matches as well
                    filtered = filtered.filter(item => {
                        return new RegExp('.*' + cleanSearchTerm + '.*', 'gi').test(item.dataVariable.name.replace('_', ' '));
                    });
                }

                // Sort alphabetically
                let alphaSorted = filtered.sort((a, b) => {
                    if (a.dataVariable.name < b.dataVariable.name) return -1;
                    if (a.dataVariable.name > b.dataVariable.name) return 1;
                    return 0;
                });

                // Return newly added variables first (with
                return alphaSorted.sort((a, b) => {
                    if (a.recorded_value === null || typeof a.recorded_value === "undefined") return -1;
                    return 1;
                });
            }
        },

        availableDataVariables() {
            const existingIds = this.variables.map(variable => variable.dataVariable.id);

            const filtered = this.dataVariables.filter(variable => {

                // Remove non user writable from adding or exclusion
                if (variable.panelist_writable === false) {
                    return false;
                }

                // Do not show already selected variables
                if (existingIds.includes(variable.id)) {
                    return false;
                }
                return true;
            });

            return filtered;
        },
    },

    methods: {

        ...mapActions([
            'getDataVariables',
        ]),

        ...mapActions('PanelistManager', [
            'setDataVariables'
        ]),

        ...mapMutations('PanelistManager', [
            'setVariablesEditableOnly',
            'setVariablesSearchTerm',
            'setVariablesFilterModel',
        ]),

        arrayDiff(a, b) {
            return [
                ...a.filter(x => b.indexOf(x) === -1),
                ...b.filter(x => a.indexOf(x) === -1)
            ];
        },

        buildVariables() {
            this.variables = JSON.parse(JSON.stringify(this.data.data_variables));
            this.dirtyVariables = [];
            this.modified = false;
        },

        addVariablesClicked() {
            this.variablePickerModel = true;
        },

        inputChanged(event) {
            this.recordEvent(event);
        },

        dataVariablesChanged(selected) {

            const variableIds = this.variables.map(variable => variable.dataVariable.id);
            const selectedIds = selected.map(variable => variable.id);

            const diff = this.arrayDiff(variableIds, selectedIds);

            diff.forEach(id => {

                if (!variableIds.includes(id)) {
                    const added = selected.find(variable => variable.id === id);
                    this.addVariable(added);
                }
            });
        },

        recordEvent(event) {
            if (!event.hasOwnProperty('value') || !event.hasOwnProperty('deleted') ||
                !event.hasOwnProperty('valid') || !event.hasOwnProperty('uuid')) {
                throw new Error("Missing event attributes (value, deleted, uuid or valid)");
            }

            // Check if data variable already exists
            let found = this.dirtyVariables.find(item => item.uuid === event.uuid);

            if (found) {
                found.value = event.value;
                found.valid = event.valid;
                found.deleted = event.deleted;

            } else {

                this.dirtyVariables.push({
                    uuid: event.uuid,
                    value: event.value,
                    valid: event.valid,
                    deleted: event.deleted,
                });
            }
            this.modified = true;
        },

        saveClicked() {
            // Make sure all fields are valid
            let found = this.dirtyVariables.find(item => {
                return item.valid === false;
            });

            if (found) {
                Bus.$emit('flash-message', {
                    type: 'error',
                    message: 'Data variables contain errors or missing data. Please review!'
                });

                return;
            }

            this.setDataVariables({panelist_id: this.$route.params.id, data: this.dirtyVariables})
                .then(() => {

                    this.dirtyVariables = [];

                    Bus.$emit('flash-message', {
                        message: 'Data Variables updated!'
                    });
                })
                .catch(({response}) => {

                    this.errorBag = response.data.errors;

                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: response.data.message
                    });
                });
        },


        addVariable(variable) {

            this.variables.push({
                dataVariable: variable,
                answer_data: null,
            })
        },

        deleteVariable(variable) {

            const event = {
                uuid: variable.uuid,
                value: null,
                valid: true,
                deleted: true,
            };

            this.recordEvent(event);

            // Remove from the array of available
            let index = this.variables.findIndex(item => item.dataVariable.uuid === variable.uuid);

            if (index === -1) {
                throw new Error('FAILED TO FIND ITEM!');
            }
            this.variables.splice(index, 1);
        },
    }
}
</script>
